export class CoreModel {}
